// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { testTemplateAttributeId } from './TestTemplateAttribute';
import { operatorId } from './Operator';
import { z } from 'zod';
export const foodMeasurementTypeId = (z.number());
export const foodMeasurementType = z.object({
    id: foodMeasurementTypeId,
    name: z.string(),
    default_unit: z.string().nullable(),
    description: z.string().nullable(),
    value_type: z.string(),
    created_at: z.date().nullable(),
    deleted_at: z.date().nullable(),
    test_template_attribute_id: testTemplateAttributeId.nullable(),
    deleted_by: operatorId.nullable(),
});
export const foodMeasurementTypeInitializer = z.object({
    id: foodMeasurementTypeId.optional(),
    name: z.string(),
    default_unit: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    value_type: z.string().optional(),
    created_at: z.date().optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    test_template_attribute_id: testTemplateAttributeId.optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const foodMeasurementTypeMutator = z.object({
    id: foodMeasurementTypeId.optional(),
    name: z.string().optional(),
    default_unit: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    value_type: z.string().optional(),
    created_at: z.date().optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    test_template_attribute_id: testTemplateAttributeId.optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FoodMeasurementType.js.map